import React, { Suspense, useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@emotion/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LoadingView from "./components/elements/LoadingView";
import { unauthAxiosFetcher } from "./axios";
import { GlobalStateProvider } from "./customHooks/useGlobalState";
import { getUserById } from "./services/user";
import { convertIsoToExtended } from "./utils/multi-language";
import Toaster from "./components/common/Toaster";
import { initFrontendSentry } from "./sentry/init";
import { sanitizeStoredUserId } from "./utils/uuid";

// Initialize error/performance monitoring before anything renders so boot-time
// failures (incl. the getUser hydration path) are captured.
initFrontendSentry();

// Drop a malformed USER_ID before any request fires — a poisoned id would
// otherwise be attached to every call and 500 getUserById on repeat.
sanitizeStoredUserId();

const theme = createTheme({
  palette: {
    primary: {
      lighter: "#CCFFFD",
      light: "#66EEFF",
      main: "#00BFFF",
      dark: "#006FB7",
      darker: "#00397A",
      contrastText: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "Manrope, sans-serif",
  },
});

// Function to get user's preferred language
// const getUserPreferredLanguage = async () => {
//   if (localStorage.getItem("USER_ID") && localStorage.getItem("JWT_TOKEN")) {
//     try {
//       const res = await getUserById(localStorage.getItem("USER_ID"));
//       const user = res.data;
//       if (user.preferred_language) {
//         return user.preferred_language;
//       }
//     } catch (error) {
//       console.error("Error fetching user preferred language:", error);
//     }
//   }
//   return null;
// };

// Component to load translations before rendering the app
// const TranslationLoader = ({ children }) => {
//   const [translationsLoaded, setTranslationsLoaded] = useState(false);

//   useEffect(() => {
//     const loadTranslations = async () => {
//       try {
//         // Check URL parameters first
//         const urlParams = new URLSearchParams(window.location.search);
//         const urlLangParam = urlParams.get("lang");

//         // Validate URL language parameter
//         const supportedLanguages = ["en", "zh-Hans-CN", "zh-Hant-TW"];
//         const urlLanguage = supportedLanguages.includes(urlLangParam) ? urlLangParam : null;

//         // Try to get language from URL first, then user preferences, then browser settings
//         const userPreferredLanguage = await getUserPreferredLanguage();
//         const browserLanguage = convertIsoToExtended(
//           navigator.language || navigator.userLanguage || "en"
//         );

//         const languageToUse = urlLanguage || userPreferredLanguage || browserLanguage;

//         // Only fetch translations for non-English languages
//         if (languageToUse !== "en") {
//           console.log(`Loading translations for ${languageToUse}...`);
//           const response = await unauthAxiosFetcher(
//             `/v1/translation/all/trips/${languageToUse}`
//           );

//           if (response && response.success) {
//             const { data } = response;
//             const allTranslations = {};
//             Object.entries(data).forEach(([resource, translations]) => {
//               allTranslations[resource] = translations;
//             });
//             window.__INITIAL_TRANSLATIONS__ = allTranslations;

//             // Update localStorage with the used language
//             if (!localStorage.getItem("locale")) {
//               localStorage.setItem("locale", languageToUse);
//             }
//           }
//         }

//         setTranslationsLoaded(true);
//       } catch (error) {
//         console.error("Failed to load translations:", error);
//         setTranslationsLoaded(true);
//       }
//     };

//     loadTranslations();
//   }, []);

//   if (!translationsLoaded) {
//     return <LoadingView />;
//   }

//   return children;
// };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <GlobalStateProvider>
      <Suspense fallback={<LoadingView />}>
        <App />
      </Suspense>
      {/* Single mount for the design-system toast stack (imperative `toast` API). */}
      <Toaster />
    </GlobalStateProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
